import { render } from "./CardIkea.vue?vue&type=template&id=3f394ca8&scoped=true"
import script from "./CardIkea.vue?vue&type=script&lang=js"
export * from "./CardIkea.vue?vue&type=script&lang=js"

import "./CardIkea.vue?vue&type=style&index=0&id=3f394ca8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f394ca8"]])

export default __exports__